<div class="container" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
  <div class="breadcrumb" fxLayout="row" fxFlexAlign="start" fxFlex="auto">
    <p>
      <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
      <span>Notification</span> 
    </p>
  </div>

  <div fxLayoutAlign="end center" fxFlex="none">
    <button mat-icon-button class="close-icon" (click)="navigate()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div fxLayout="column" fxFlex="100" fxLayoutGap="20px">
    <div fxLayout="row wrap" fxFlex="100" fxLayoutAlign="center">
      <div fxFlex="100" fxFlex.gt-sm="70" class="notification-div" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100" class="language-selection">
          <mat-card-header class="mat-card-heading" fxFlex="100" fxFlex.gt-sm="30">Language</mat-card-header>
          <div fxFlex="100" fxFlex.gt-sm="70" fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign.xs="start center" fxLayoutAlign.gt-xs="space-between center" fxLayoutGap="10px" fxLayoutGap.gt-sm="30px">
            <button mat-raised-button [class.selected]="selectedLanguage === 'all' || (selectedLanguage === 'en' && isFrenchFormVisible)" (click)="selectLanguage('all')">All</button>
            <button mat-raised-button [class.selected]="selectedLanguage === 'en' || (selectedLanguage === 'all' && !isFrenchFormVisible)" (click)="selectLanguage('en')">English</button>
            <button mat-raised-button [class.selected]="selectedLanguage === 'fr' || (selectedLanguage === 'all' && isFrenchFormVisible)" (click)="selectLanguage('fr')">French</button>
          </div>
        </div>        
        <div fxLayout="row" fxFlex="100" class="mat-radio-button">
          <mat-card-header class="mat-card-heading" fxFlex="100" fxFlex.gt-sm="30">Type</mat-card-header>
          <mat-radio-group [(ngModel)]="selectedCommunicationType" fxFlex="100" fxFlex.gt-sm="70">
            <mat-radio-button value="push" class="push">Push</mat-radio-button>
          </mat-radio-group>
        </div>

        <div fxLayout="row" fxFlex="100">
          <mat-card-header class="mat-card-heading" fxFlex="100" fxFlex.gt-sm="30"  matTooltip="Required for Android users" matTooltipClass="custom-tooltip">Push Title<span style="color: red;">*</span></mat-card-header>
          <mat-form-field appearance="outline" class="mat-form-field" fxFlex="100">
            <input matInput [(ngModel)]="enteredPushTitle" (ngModelChange)="onPushTitleChange($event)" [placeholder]="getPlaceholderForTitle()" maxlength="50" matTooltip="Required for Android users" matTooltipClass="custom-tooltip1">
          </mat-form-field>
        </div>

        <div fxLayout="row" fxFlex="100" fxLayoutAlign="end">
          <p class="remaining-chars">Remaining characters: {{remainingTitleChars}}</p>
        </div>

        <div fxLayout="row" fxFlex="100">
          <mat-card-header class="mat-card-heading" fxFlex="100" fxFlex.gt-sm="30">Push Body<span style="color: red;">*</span></mat-card-header>
          <mat-form-field appearance="outline" class="mat-form-field" fxFlex="100">
            <textarea matInput [(ngModel)]="enteredPushBody" [placeholder]="getPlaceholderForBody()" (ngModelChange)="onPushBodyChange($event)" maxlength="170"></textarea>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxFlex="100" fxLayoutAlign="end">
          <p class="remaining-chars">Remaining characters: {{remainingChars}}</p>
        </div>

        <div fxLayout="row" fxFlex="100">
          <mat-card-header class="mat-card-heading" fxFlex="100" fxFlex.gt-sm="30">Redirect URL<span style="color: red;">*</span></mat-card-header>
          <mat-form-field appearance="outline" class="mat-form-field" fxFlex="100">
            <input type="url" matInput [(ngModel)]="enteredURL" placeholder="Enter the Redirect URL">
          </mat-form-field>
        </div>

        <div fxLayout="row" fxFlex="100" fxLayoutAlign="end">
          <button mat-raised-button *ngIf="selectedLanguage === 'all' && isFrenchFormVisible" (click)="previousSection()" class="mat-button-prev">Previous</button>
          <button mat-raised-button *ngIf="selectedLanguage === 'all' && !isFrenchFormVisible" (click)="nextSection()" class="mat-button-create">Next</button>
          <button mat-raised-button *ngIf="selectedLanguage !== 'all' || (selectedLanguage === 'all' && isFrenchFormVisible)" (click)="createNotification()" class="mat-button-create">Create</button>
        </div>

        <div fxLayout="row" fxFlex="100">
          <div fxFlex="90" fxLayoutAlign="center">
            <mat-card-header *ngIf="errorMessage" class="errorMessage">{{errorMessage}}</mat-card-header>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
